import IcSensorWindow from './IcSensorWindow'

export default IcSensorWindow
